import { TreeViewDragAnalyzer } from "@progress/kendo-react-treeview";

const SEPARATOR = "_";

function getSiblings(itemIndex, data) {
    let result = data;

    const indices = itemIndex.split(SEPARATOR).map((index) => Number(index));

    for (let i = 0; i < indices.length - 1; i++) {
        result = result[indices[i]].items;
    }

    return result;
}

function getElement(itemIndex, data) {
    let result;

    const indices = itemIndex.split(SEPARATOR).map((index) => Number(index));

    for (let i = 0; i < indices.length; i++) {
        if (result === undefined) {
            result = data[indices[i]];
        } else {
            result = result.items[indices[i]];
        }
    }

    return result;
}

export function getClassOfDragEvent(event, data) {
    const eventAnalyzer = new TreeViewDragAnalyzer(event).init();
    const { itemHierarchicalIndex: positionIndex } = event;
    const { itemHierarchicalIndex: itemIndex } =
        eventAnalyzer.destinationMeta;

    if (eventAnalyzer.isDropAllowed) {
        const siblings = getSiblings(itemIndex, data);
        switch (eventAnalyzer.getDropOperation()) {
            case "child":
                return "k-i-cancel";
            case "before":
                if (positionIndex.length !== itemIndex.length) {
                    return "k-i-cancel";
                }

                if (event.item.type === "folder" && itemIndex.length > 1) {
                    return "k-i-cancel";
                }

                if (positionIndex.charAt("0") !== itemIndex.charAt("0")) {
                    return "k-i-cancel";
                }

                return itemIndex === "0" ||
                    itemIndex.endsWith(`${SEPARATOR}0`)
                    ? "k-i-insert-up"
                    : "k-i-insert-middle";
            case "after":
                if (positionIndex.charAt(0) !== itemIndex.charAt(0)) {
                    return "k-i-cancel";
                }
                if (siblings !== undefined) {
                    const lastIndex = Number(
                        itemIndex.split(SEPARATOR).pop()
                    );
                    return lastIndex < siblings.length - 1
                        ? "k-i-insert-middle"
                        : "k-i-insert-down";
                } else {
                    if (
                        event.item.type === "folder" &&
                        itemIndex.length > 1
                    ) {
                        return "k-i-cancel";
                    }

                    return "k-i-insert-down";
                }
            default:
                break;
        }
    }

    return ["k-i-cancel", false];
}

export function getOrderOfReorderedPages(event, data) {
    const eventAnalyzer = new TreeViewDragAnalyzer(event).init();

    if (eventAnalyzer.isDropAllowed) {
        const { itemId, destItemId } = eventAnalyzer;
        const icon = getClassOfDragEvent(event, data);
        const droppedInOtherFolder = isDroppedInOtherFolder(
            itemId,
            destItemId
        );

        const targetFolderSiblings = getSiblings(
            destItemId,
            data
        );

        const targetTreeIndex = destItemId
            .split(SEPARATOR)
            .map((index) => Number(index));
        const targetIndex = targetTreeIndex[targetTreeIndex.length - 1];

        if (droppedInOtherFolder) {
            const target = getElement(destItemId, data);
            const dragged = getElement(itemId, data);
            return {
                target, dragged,
                droppedInOtherFolder: true,
                targetOrder: target.order, draggedOrder: dragged.order
            };
        } else if (icon !== "k-i-cancel") {
            const dropOperation = eventAnalyzer.getDropOperation();

            const target = getElement(destItemId, data);
            const dragged = getElement(itemId, data);

            const targetNextNeighbour =
                targetFolderSiblings[targetIndex + 1];
            const targetPrevNeighbour =
                targetFolderSiblings[targetIndex - 1];

            let order = 100000;
            let targetOrder = parseInt(target.order);
            let nextNeighbourOrder = parseInt(targetNextNeighbour?.order);
            let prevNeighourOrder = parseInt(targetPrevNeighbour?.order);

            if (dropOperation === "before") {
                if (targetIndex === 0) {
                    order = target.order;
                    if (targetNextNeighbour) {
                        targetOrder = (targetOrder + nextNeighbourOrder) / 2;
                    } else {
                        targetOrder += 10000000000;
                    }
                } else if (
                    targetIndex ===
                    targetFolderSiblings.length - 1
                ) {
                    order = target.order;
                    targetOrder += 10000000000;
                } else {
                    order = (targetOrder + prevNeighourOrder) / 2;
                }
            } else {
                if (targetIndex === targetFolderSiblings.length - 1) {
                    order = targetOrder + 10000000000;
                } else {
                    order = (nextNeighbourOrder + targetOrder) / 2;
                }
            }

            targetOrder = String(targetOrder);
            order = String(order);

            return {
                target, dragged,
                droppedInOtherFolder: false,
                targetOrder, draggedOrder: order
            };
        }
    }
}

export function isDroppedInOtherFolder(draggedId, targetId) {
    const draggedIndexes = draggedId.split(SEPARATOR);
    const targetIndexes = targetId.split(SEPARATOR);

    return draggedIndexes[0] !== targetIndexes[0];
}